export default __webpack_public_path__ + "static/media/envirement.9709d698.svg";